export const hexTileUrl = (n: number): string =>
  `${import.meta.env.BASE_URL}images/hexes/bottom/hex${n}.png`;

export const zoneHexUrl = (isPlayer: boolean, tournament = false): string => {
  const role = isPlayer ? "Team" : "Enemy";
  const file = tournament ? `tournament${role}Hex` : `${role.toLowerCase()}Hex`;
  return `${import.meta.env.BASE_URL}images/hexes/bottom/${file}.png`;
};

export const DDRAGON_VERSION = "16.8.1";
export const DDRAGON_CDN = `https://ddragon.leagueoflegends.com/cdn/${DDRAGON_VERSION}`;

export const championIconUrl = (championId: string): string =>
  `${DDRAGON_CDN}/img/champion/${championId}.png`;

export const itemIconUrl = (itemId: number | string): string =>
  `${DDRAGON_CDN}/img/item/${itemId}.png`;

export const abilityIconUrl = (spellId: string): string =>
  `${DDRAGON_CDN}/img/spell/${spellId}.png`;

// Hex grid — vertical mobile layout, enemies top rows, players bottom rows.
export const GRID_COLS = 3;
export const GRID_ROWS = 8;

// All cells use hex1 — uniform battle floor.
export const randomTileLayout = (): number[] => {
  const total = GRID_COLS * GRID_ROWS;
  return new Array(total).fill(1);
};

// Hex sizing is computed per-frame from the live canvas size in CombatScene.
export const HEX_SIZE_DEFAULT = 28;

// Animation timings (ms)
export const TIMING = {
  movePerHex: 180,
  attackLunge: 180,
  attackRecoil: 150,
  abilityWindup: 220,
  abilityActive: 420,
  damagePopupDuration: 900,
  hitFlash: 220,
  deathFade: 420,
  turnGapMs: 80,
} as const;

// Legal disclaimer (required on every screen by Riot Games IP policy)
export const LEGAL_FOOTER =
  "LoL Rogue isn't endorsed by Riot Games and doesn't reflect the views or opinions of Riot Games or anyone officially involved in producing or managing Riot Games properties. Riot Games, and all associated properties are trademarks or registered trademarks of Riot Games, Inc.";

// ---- Act / map config ----
// 7 layers: index 0 = start node (width 1), indices 1-5 = normal, index 6 = boss.
export const LAYER_WIDTHS: readonly number[] = [1, 2, 3, 4, 3, 2, 1];
export const LAYER_COUNT = LAYER_WIDTHS.length;
export const START_LAYER  = 0;
export const BOSS_LAYER   = LAYER_COUNT - 1; // 8
export const BACKPORT_LAYER = LAYER_COUNT - 2; // 7
